import React from "react";
import Dropdown from "../DropDown";

interface MarketTypeDropdownProps {
  selectedMarketType: string;
  onMarketTypeChange: (selectedMarketType: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
  isoCode: string; // ISO passed from parent
}

const MarketTypeDropdown: React.FC<MarketTypeDropdownProps> = ({
  selectedMarketType,
  onMarketTypeChange,
  disabled,
  className = "",
  onFocus,
  isoCode
}) => {
  // Mapping ISO → Market Type options
  const isoMarketMap: Record<string, string[]> = {
    ALL: ["DAM", "RTM"],
    CAISO: ["DAM", "RTUC", "RTM"],
    ERCOT: ["DAM", "RTM"],
    ISONE: ["DAM", "RTM"],
    NYISO: ["DAM", "RTM"],
    PJM: ["DAM", "RTM"],
  };

  const options =
    isoMarketMap[isoCode]?.map((mkt) => ({ value: mkt, label: mkt })) ?? [];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedMarketType}
      onValueChange={onMarketTypeChange}
      disabled={disabled}
      className={className}
      placeholder="Select Market Type"
      onFocus={onFocus}
    />
  );
};

export default MarketTypeDropdown;
